import type { MailGroupFolderRouteParameters } from './utils/mailGroupRouteSettings';
import { ensureValidGroupSmtpAddress } from './utils/mailGroupRouteSettings';
import selectRow from './selectRow';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';
import { lazySwitchToGroupsModule } from 'owa-groups-dash-nav-actions/lib/lazyCalendarBoot';
import { lazyLoadGroupsList } from 'owa-groups-left-nav-actions/lib/lazyFunction';

export default async function mailGroupFolderRouteHandler(
    parameters: MailGroupFolderRouteParameters
): Promise<void> {
    const groupSmtp = ensureValidGroupSmtpAddress(parameters);
    if (!groupSmtp) {
        return;
    }
    const mailboxInfo = getGlobalSettingsAccountMailboxInfo();
    await lazyLoadGroupsList.importAndExecute(
        mailboxInfo,
        false /*isReload*/,
        true /*SubscribeAll */
    );
    lazySwitchToGroupsModule.importAndExecute(
        mailboxInfo,
        groupSmtp,
        parameters.folderId,
        undefined /*tabId*/,
        'MailAppGroupsFolderRouting'
    );
}

export async function mailGroupFolderRowRouteHandler(
    parameters: MailGroupFolderRouteParameters
): Promise<void> {
    await mailGroupFolderRouteHandler(parameters);

    if (parameters.rowId) {
        selectRow(parameters.rowId);
    }
}
